import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface TabItemProps {
    active1: string;
}
export const NavigationItemWrapper = styled.div.attrs(
    (props: TabItemProps) => ({
        className: props.active1
    })
)`
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 5px;
    //border: solid 1px #fff;
    border-radius: 10px;

    &.active {
        border: solid 1px #fff;
    }
    &.inactive {
        border: none;
    }
`;

export const ItemName = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    margin-top: 6px;
`;

export const ItemLink = styled(Link)`
    text-decoration: none;
    display: flex;
    width: 100%;
    height: 80px;
    color: #fff;
    :active {
        color: #fff;
    }
    :hover {
        color: #fff;
    }
`;

export const ItemContainer = styled.div`
    display: flex;
    width: 100%;
    height: 80px;
    color: #fff;
    cursor: pointer;
`;
